export default __webpack_public_path__ + "static/media/ic_file.d8dc4870.svg";